import React from 'react';

import PropTypes from 'prop-types';
import Nav from 'react-bootstrap/Nav';

import SearchModal from '@src/components/search/SearchModal';

class HeaderMenuSearchItem extends React.PureComponent {
    static propTypes = {
        displayName: PropTypes.string,
        onShow: PropTypes.func,
    };

    constructor(props) {
        super(props);
        // eslint-disable-next-line react/state-in-constructor
        this.state = {
            showModal: false,
        };
    }

    handleClick = (e) => {
        e.preventDefault();

        this.setState({ showModal: true });

        if (this.props.onShow) {
            this.props.onShow();
        }
    };

    closeModal = () => {
        this.setState({ showModal: false });
    };

    handleEsc = (e) => {
        if (e.key === 'Escape') {
            this.closeModal();
        }
    };

    renderModal = () => {
        if (!this.state.showModal) {
            return null;
        }

        return (
            <SearchModal
                onClose={this.closeModal}
                onKeyDown={this.handleEsc}
                onSubmit={this.closeModal}
            />
        );
    };

    render() {
        const { displayName } = this.props;

        return (
            <>
                <Nav.Item className="search-item">
                    <Nav.Link
                        className="search-icon"
                        title={displayName}
                        tabIndex={1000}
                        onClick={this.handleClick}
                    >
                        <img src="/img/icons/search-icon-top-menu.svg" alt="search" />
                    </Nav.Link>
                </Nav.Item>
                { this.renderModal() }
            </>
        );
    }
}

export default HeaderMenuSearchItem;
